// extracted by mini-css-extract-plugin
export default {"container":"QSC6cFb8Y5zy6xhq_cOA","title":"IQjc7GHFsyn168BO3RMJ","value":"QnghdUbdh6CMv2E5IiLd"};